module.exports = __webpack_public_path__ + "images/login_icon_verification_yellow.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/login_icon_verification_yellow.png
// module id = 883
// module chunks = 124